import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, Stack, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import { lookupAmlSubject } from '../../utils/amlApi';
import { matchStatusLabel } from '../../utils/amlSchema';

const RISK_GORUNUMU = {
  strong: { etiket: 'Kritik', renk: 'error', nokta: '#dc2626' },
  possible: { etiket: 'İnceleme', renk: 'warning', nokta: '#d97706' },
  clear: { etiket: 'Temiz', renk: 'success', nokta: '#16a34a' }
};

/**
 * @param {'dot'|'chip'} [display] Listede satir basina yalniz renkli daire
 *   gosteriliyor; "Temiz" yazisi her satirda tekrar edip yer kapliyordu.
 *   Etiket tooltip'te duruyor.
 */
export function InvoiceAmlRiskChip({ status, size = 'small', display = 'chip' }) {
  const gorunum = RISK_GORUNUMU[status];
  if (!gorunum) return null;
  if (display === 'dot') {
    return (
      <Tooltip title={gorunum.etiket}>
        <Box
          component="span"
          aria-label={gorunum.etiket}
          sx={{
            display: 'inline-block',
            width: 11,
            height: 11,
            borderRadius: '50%',
            bgcolor: gorunum.nokta,
            flexShrink: 0
          }}
        />
      </Tooltip>
    );
  }
  return <Chip size={size} color={gorunum.renk} label={gorunum.etiket} sx={{ fontWeight: 800 }} />;
}

export function InvoiceAmlQuickCheck({ sube, name, taxId, initialStatus }) {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(initialStatus || null);

  useEffect(() => {
    setStatus(initialStatus || null);
  }, [initialStatus, name, taxId]);

  const canRun = String(name || '').trim().length > 1 || String(taxId || '').replace(/\D/g, '').length >= 10;

  const run = async (e) => {
    e?.stopPropagation?.();
    if (!canRun) {
      toast.error('TCKN/VKN veya ad soyad girin');
      return;
    }
    setBusy(true);
    try {
      const r = await lookupAmlSubject({
        sube,
        name,
        taxId
      });
      setStatus(r.status || 'clear');
      toast.success(matchStatusLabel(r.status || 'clear'));
    } catch (err) {
      toast.error(err?.message || 'Kontrol edilemedi');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      <InvoiceAmlRiskChip status={status} />
      <Button
        size="small"
        variant="outlined"
        disabled={busy || !canRun}
        onClick={run}
        sx={{ textTransform: 'none', fontWeight: 800, whiteSpace: 'nowrap' }}
      >
        {busy ? 'Kontrol…' : 'Risk kontrolü'}
      </Button>
    </Stack>
  );
}
